const formatToTwoDecimalPlaces = (value) => {
  if (isNaN(value)) return "Invalid number"; // Handle invalid inputs
  const [integerPart, decimalPart] = value.toString().split(".");
  if (!decimalPart) return integerPart; // No decimals
  return integerPart + "." + decimalPart.slice(0, 2); // Truncate decimals to 2 places
};

const numbersHelper = {
  formatToTwoDecimalPlaces,
};
export default numbersHelper;
